interface MascotSectionProps {
  className?: string;
}

export function MascotSection({ className = '' }: MascotSectionProps) {
  return (
    <div className={`flex flex-col items-center text-center ${className}`}>
      {/* Mascot image */}
      <div className="relative mb-4 animate-bounce-gentle">
        <div className="w-36 h-36 rounded-full bg-gradient-to-br from-beaver-cream to-beaver-ivory
                        shadow-card flex items-center justify-center overflow-hidden border-4 border-white">
          <img
            src="/images/tools-beaver-mascot-logo.png"
            alt="Tim the Beaver mascot"
            className="w-full h-full object-cover"
            onError={(e) => {
              // Fallback when image not yet available
              const target = e.currentTarget;
              target.style.display = 'none';
              target.nextElementSibling?.removeAttribute('style');
            }}
          />
          {/* Fallback SVG mascot */}
          <div className="absolute inset-0 flex items-center justify-center text-7xl" style={{ display: 'none' }}>
            🦫
          </div>
        </div>
        {/* Green cap badge */}
        <div className="absolute -top-1 -right-1 w-10 h-10 bg-garden-500 rounded-full
                        flex items-center justify-center shadow-tim border-2 border-white">
          <span className="text-white text-[10px] font-black tracking-wider">TIM</span>
        </div>
      </div>

      {/* Welcome message */}
      <h1 className="font-display font-extrabold text-2xl sm:text-3xl text-silver-800 leading-tight mb-1.5">
        Welcome to{' '}
        <span className="text-garden-600">Tools Beaver!</span>
      </h1>
      <p className="text-silver-500 text-sm sm:text-base mb-2">
        Your neighborhood tool sharing platform.
      </p>

      {/* Slogan */}
      <div className="flex items-center gap-2 text-sm font-semibold text-beaver-amber">
        <span>Share.</span>
        <span className="w-1 h-1 rounded-full bg-beaver-gold" />
        <span>Rest.</span>
        <span className="w-1 h-1 rounded-full bg-beaver-gold" />
        <span>Build.</span>
      </div>
    </div>
  );
}
